import { render, staticRenderFns } from "./quotaAccountLog.vue?vue&type=template&id=6201f9bd&scoped=true"
import script from "./quotaAccountLog.vue?vue&type=script&lang=js"
export * from "./quotaAccountLog.vue?vue&type=script&lang=js"
import style0 from "./quotaAccountLog.vue?vue&type=style&index=0&id=6201f9bd&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6201f9bd",
  null
  
)

export default component.exports